import { S, ui } from "../app/store.js";
import { today } from "../domain/dates.js";
import { permissionsForRole } from "../domain/reference.js";

const me = () => S.users.find((u) => u.id === ui.user);

const can = (p) => {
  const u = me();
  if (!u || (u.status && u.status !== "ACTIVE")) return false;
  if (u.expires && today() > u.expires) return false;
  return permissionsForRole(S.roles, u.role).includes(p);
};

const uname = (id) => S.users.find((u) => u.id === id)?.name || id || "—";

const emp = (id) => S.employees.find((e) => e.id === id);

function leaveScope() {
  const u = me();
  if (can("leave.all")) return S.leaves;
  if (can("leave.team"))
    return S.leaves.filter(
      (l) => emp(l.emp)?.dept === u.dept && l.emp !== u.emp,
    );
  return [];
}

function used(empId, type) {
  return S.leaves
    .filter(
      (l) => l.emp === empId && l.type === type && l.status === "APPROVED",
    )
    .reduce((a, l) => a + l.days, 0);
}

const canInvoice = () => can("inv.issue"),
  canCompany = () => can("period.lock") || can("bir.file");

const depMoney = () => can("hr.salary") || can("fs.view");

const canDepAct = (a) =>
  ["dep-raise", "dep-contract", "dep-osh", "dep-extend", "dep-report"].includes(
    a,
  )
    ? can("dep.manage")
    : true;

export {
  me,
  can,
  uname,
  emp,
  leaveScope,
  used,
  canInvoice,
  canCompany,
  depMoney,
  canDepAct,
};
